import React, { FunctionComponent, useContext } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AuthStore } from '../context';
import { ErrorBoundary } from '../components/ErrorBoundary';

export const PrivateRoute: FunctionComponent<RouteProps> = props => {
  const { component: Component, render, children, ...rest } = props;
  const {
    state: { auth, status },
  } = useContext(AuthStore);
  const acknowledgments =
    (auth && auth.user && auth.user.acknowledgments) || {};

  return (
    <Route
      {...rest}
      render={props => {
        switch (true) {
          case status === 'notauthed':
            return <Redirect to="/login" />;
          case rest.path === '/application/account' &&
            acknowledgments.setPassword:
            return <Redirect to="/application/business" />;
          default:
            if (render) {
              return render(props);
            } else if (Component) {
              return (
                <ErrorBoundary>
                  <Component {...props} />
                </ErrorBoundary>
              );
            } else {
              return children as React.ReactNode;
            }
        }
      }}
    />
  );
};
